const SpacingsValues = Object.freeze({
    s0: 0,
    s2: 2,
    s4: 4,
    s6: 6,
    s8: 8,
    s10: 10,
    s12: 12,
    s16: 16,
    s24: 24,
    s32: 32,
    s40: 40,
    s44: 44,
    s48: 48,
    s56: 56,
    s64: 64,
    s72: 72,
});

export { SpacingsValues };
